import { sessionStorageApi } from './storage';

const sessionPreviousLocation = sessionStorageApi('previousLocation');
const storageAfterLogin = sessionStorageApi('afterLogin');
const storageClaimedPromo = sessionStorageApi('claimedPromo');
const storageClaimedProductId = sessionStorageApi('claimedProductId');

export { sessionPreviousLocation, storageAfterLogin, storageClaimedPromo, storageClaimedProductId };
